import React from "react";
import classes from "./VideoPlayer.module.scss";
import YouTube from "react-youtube";
import classNames from "classnames";

const VideoPlayer = ({ video, options, classCustom }) => {
  return (
    <div className={classNames(classes.videoPlayer, classCustom)}>
      <YouTube
        videoId={video}
        opts={options}
        containerClassName={classes.video}
        className={classes.test}
      />
    </div>
  );
};

export default VideoPlayer;
